import 'intersection-observer'
import { Base_createBus } from '../zap/Base/Base.Bus'
import { timeout } from '../../shared/lib/timeout.no-deps'
import { Evnt_handleOpenURL } from '../zap/Evnt/Evnt.handleOpenURL'
import { Evnt_onActivity } from '../zap/Evnt/Evnt.onActivity'
import { Evnt_onLoad } from '../zap/Evnt/Evnt.onLoad'
import { Evnt_onResize } from '../zap/Evnt/Evnt.onResize'
import { Evnt_onResume } from '../zap/Evnt/Evnt.onResume'
import { Rout_AppRouter } from '../zap/Rout/Rout.AppRouter'
import { Rout_toReportView } from '../zap/Rout/Rout.report'
import { Rout_toProcedureContentPage } from '../zap/Rout/Rout.procedure'
import { Rout_toPost } from '../zap/Rout/Rout.post'
import { Rout_toTodo } from '../zap/Rout/Rout.todo'
import type { NominalUUID } from '../../shared/lib/typeHelpers.no-deps'
import * as Sentry from '@sentry/browser'
import { shouldUseSentry } from '../../shared/lib/sentry-helpers'
import * as ZendeskWebChat from '../../app-core/lib/util/zendeskWebChat'
import { attachFeatureFlagsToWindow } from '../zap/Util/Util.window'

async function initialise() {
    ZendeskWebChat.hideChat()

    const bus = Base_createBus()

    // Attach global event handlers
    window.addEventListener('load', () => Evnt_onLoad(Rout_AppRouter, bus))
    window.addEventListener('resize', Evnt_onResize)
    document.addEventListener('resume', (event: CordovaResumeEvent) => Evnt_onResume(bus, event))
    window.handleOpenURL = (url) => Evnt_handleOpenURL(url, bus)
    window.addEventListener('mousedown', Evnt_onActivity)
    window.addEventListener('touchstart', Evnt_onActivity)
    window.addEventListener('keypress', Evnt_onActivity)

    attachFeatureFlagsToWindow()

    // Device ready event is handled with onLoad because it does not work like a normal event
    // The event is fired as soon as you attach if the event would have already fired
    // Using this to our advantage, it's much easier to have single startup than concurrent
    // events.
    //
    // However, we want code-push to update no matter what, so safer to put here on it's own
    document.addEventListener('deviceready', async () => {
        // Only need to do updates in production
        if (!ENV.isProduction) return

        while (true) {
            // Install code push updates
            window.codePush.sync(null, { installMode: InstallMode.ON_NEXT_RESUME })

            // Try again in an hour
            await timeout(1000 * 60 * 60)
        }
    })

    document.addEventListener('deviceready', () => {
        universalLinks.subscribe('onProcedureLink', (event) => {
            const [, , , , , procedureId] = event.url.split('/')
            Rout_toProcedureContentPage(Number(procedureId))
        })

        universalLinks.subscribe('onPostCommentLink', (event) => {
            const [, , , , , postId, ,] = event.url.split('/')
            Rout_toPost(postId as NominalUUID<'TAppPostId'>, Rout_toTodo)
        })

        universalLinks.subscribe('onReportLink', (event) => {
            const [, , , , , reportId] = event.url.split('/')
            Rout_toReportView(Number(reportId))
        })
    })

    if (shouldUseSentry()) {
        Sentry.init({
            dsn: 'https://681c9108c2e14aa3a91fe1ac7eb2d948@o51287.ingest.sentry.io/4505437348888576',
            replaysSessionSampleRate: 0.4,
            replaysOnErrorSampleRate: 1.0,

            integrations: (integrations) =>
                integrations
                    .filter((integration) => !['GlobalHandlers', 'TryCatch', 'Breadcrumbs'].includes(integration.name))
                    .concat([new Sentry.Replay({ maskAllText: false, maskAllInputs: false, blockAllMedia: true })]),

            ignoreErrors: [/^((?!trigger-replay).)*$/gi],

            tracesSampler: (samplingContext) => {
                if (samplingContext.transactionContext.name === 'Auth_loginSync') return 1
                return 0.05
            },
        })
    }
}

initialise()
